import { auth, user, search, hubSelectorDisabler, } from '@/router-middleware';
import apiAbort from '@/router-middleware/api-abort';
import { i18n } from '@/locales';
export default {
    middleware: [
        auth,
        user,
        search,
        hubSelectorDisabler,
        apiAbort,
    ],
    requiresAppBar: false,
    requiresBottomNavigation: false,
    /**
     * navIcon
     * @default menu
     * {menu,up}
     */
    navIcon: 'menu',
    /**
     * actionItems
     * @type {Array}
     * @default [search,settings]
     * [search,settings,plus,map,edit,workers]
     */
    actionItems: [
        'search',
        'settings',
    ],
    breadcrumbsItems: {
        storeAdjustment: {
            list: [
                {
                    text: '상점',
                    href: '/vuex-store',
                    disabled: false,
                },
                {
                    text: '정산',
                    href: '/vuex-store/adjustment',
                    disabled: true,
                },
            ],
            detail: [
                {
                    text: '상점',
                    href: '/vuex-store',
                    disabled: false,
                },
                {
                    text: '정산',
                    href: '/vuex-store/adjustment',
                    disabled: false,
                },
            ],
        },
        worker: {
            adjustment: [
                {
                    text: '라이더',
                    href: '/worker',
                    disabled: false,
                },
                {
                    text: '정산',
                    href: '/worker/adjustment',
                    disabled: false,
                },
            ],
        },
        baromoneyReport: {
            basic: [
                {
                    text: i18n.t('views.menu.baromoney_report'),
                    href: '/baromoney-report',
                    disabled: true,
                },
            ],
        },
    },
};
